<template>
  <v-app id="inspire">
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <SuccessModal ref="SuccessModal"></SuccessModal>
    <Loader ref="Loader"></Loader>
    <v-content>
      <v-img style="position: fixed; width: 100%; height: 100%" position="100% 100%" src="Attraction/Login.jpeg"
        gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"></v-img>
      <v-container justify-center>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>

        <v-layout ma-5 align-center justify-center>
          <v-flex xs16 sm10 md8 lg8 xl8>
            <v-card class="elevation-12">
              <v-form @submit.prevent="Submit">
                <v-card-text>
                  <v-layout align-center justify-center row mb-2>
                    <v-img width="100%" height="100%" src="Attraction/suburban.png">
                    </v-img>
                  </v-layout>
                  <v-text-field v-model="reviewedBy" color="primary" prepend-icon="person" label="Reviewed by:"
                    type="text"></v-text-field>

                  <table style="width: 100%">
                    <tr>
                      <th :style="`width: ${header.width}%;`" v-for="header in headers" :key="header.value">
                        {{ header.name }}
                      </th>
                    </tr>
                    <tr :style="rowStyle(row)" v-for="row in rows" :key="row.value">
                      <td>{{ row.text }}</td>

                      <td :style="`text-align: center;` + ratingStyle" v-if="row.type == 0">
                        <star-rating v-model="row.rating" style="justify-content: center" :increment="1" :max-rating="5"
                          inactive-color="#000" active-color="#f00" :star-size="mobile_break ? 30 : 10"
                          :show-rating="false">
                        </star-rating>
                      </td>
                      <td v-else-if="row.type == 1">&nbsp;</td>
                      <td v-else>{{ total }}</td>

                      <td style="text-align: center; max-height: 35px" v-if="row.type == 0">
                        <input style="line-height: 35px; width: 100%" type="text" v-model="row.comment" />
                      </td>
                      <td v-else>&nbsp;</td>
                    </tr>
                  </table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="primary">submit</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app dark inset fixed color="darkgray">
      <v-spacer></v-spacer>
      <div>
        Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}
      </div>
    </v-footer>
  </v-app>
</template>

<script>
  import StarRating from "vue-star-rating";

  export default {
    data() {
      return {
        reviewedBy: "",
        headers: [{
            value: 1,
            name: "Quality",
            width: 30,
          },
          {
            value: 2,
            name: "Rating",
            width: 15,
          },
          {
            value: 3,
            name: "Comments",
            width: 45,
          },
        ],
        rows: [{
            value: 1,
            text: "A. Quality Service provided",
            rating: 0,
            comment: "",
            comment_prop: "QualityOfServiceComments",
            rating_prop: "QualityOfServiceRating",
            type: 0,
          },
          {
            value: 2,
            text: "B. Response Times",
            rating: 0,
            comment: "",
            comment_prop: "ResponseTimeComments",
            rating_prop: "ResponseTimeRating",
            type: 0,
          },
          {
            value: 3,
            text: "C. Food Safety Compliance",
            rating: 0,
            comment: "",
            comment_prop: "FoodSafteyComplianceComments",
            rating_prop: "FoodSafteyComplianceRating",
            type: 0,
          },
          {
            value: 4,
            text: "D. NCR raised against Service provider",
            rating: 0,
            comment: "",
            comment_prop: "NCRRaisedAgainstServiceProviderComments",
            rating_prop: "NCRRaisedAgainstServiceProviderRating",
            type: 0,
          },
          {
            value: 5,
            text: "",
            rating: 0,
            comment: "",
            comment_prop: "",
            rating_prop: "",
            type: 1,
          },
          {
            value: 6,
            text: "Performance",
            rating: 0,
            comment: "",
            comment_prop: "",
            rating_prop: "",
            type: 1,
          },
          {
            value: 7,
            text: "A. Technical Ability",
            rating: 0,
            comment: "",
            comment_prop: "TechnicalAbilityComments",
            rating_prop: "TechnicalAbilityRating",
            type: 0,
          },
          {
            value: 8,
            text: "B. Capability",
            rating: 0,
            comment: "",
            comment_prop: "CapabilityComments",
            rating_prop: "CapabilityRating",
            type: 0,
          },
          {
            value: 9,
            text: "C. Technical Assistance",
            rating: 0,
            comment: "",
            comment_prop: "TechnicalAssistanceComments",
            rating_prop: "TechnicalAssistanceRating",
            type: 0,
          },
          {
            value: 10,
            text: "D. Would you consider renewing contract",
            rating: 0,
            comment: "",
            comment_prop: "RenewContractComments",
            rating_prop: "RenewContractRating",
            type: 0,
          },
          {
            value: 11,
            text: "",
            rating: 0,
            comment: "",
            comment_prop: "",
            rating_prop: "",
            type: 1,
          },
          {
            value: 12,
            text: "Total rating",
            rating: 0,
            comment: "",
            comment_prop: "",
            rating_prop: "",
            type: 2,
          },
        ],
      };
    },
    components: {
      StarRating,
    },
    computed: {
      total() {
        return this.rows.reduce((n, {
          rating
        }) => n + rating, 0);
      },
      ratingStyle() {
        return this.mobile_break ? "" : " width: 50px; max-width: 50px";
      },
      mobile_break() {
        return this.$vuetify.breakpoint.mdAndUp;
      },
    },
    mounted() {},
    methods: {
      rowStyle(row) {
        switch (row.type) {
          case 0:
            return !this.mobile_break ? "font-size: 10px" : "";
          case 1:
            return !this.mobile_break ?
              "font-weight: 600; font-size: 12px" :
              "font-weight: 600; font-size: 16px";
          case 2:
            return !this.mobile_break ?
              "font-weight: 600; font-size: 14px" :
              "font-weight: 600; font-size: 18px";
          default:
            return "";
        }
      },
      isValid(form) {
        if (
          form.QualityOfServiceRating != null &&
          form.QualityOfServiceRating != "" &&
          form.ResponseTimeRating != null &&
          form.ResponseTimeRating != "" &&
          form.FoodSafteyComplianceRating != null &&
          form.FoodSafteyComplianceRating != "" &&
          form.NCRRaisedAgainstServiceProviderRating != null &&
          form.NCRRaisedAgainstServiceProviderRating != "" &&
          form.TechnicalAbilityRating != null &&
          form.TechnicalAbilityRating != "" &&
          form.CapabilityRating != null &&
          form.CapabilityRating != "" &&
          form.TechnicalAssistanceRating != null &&
          form.TechnicalAssistanceRating != "" &&
          form.RenewContractRating != null && form.RenewContractRating != "" && form.CustomerID != 0 && form
          .CustomerID != null && form.ReviewedBy != null && form.ReviewedBy != ""
        ) {
          return true;
        } else {
          return false;
        }
      },
      Submit() {
        let tmpForm = {};

        tmpForm = this.rows.reduce(
          (acc, cur) => ({
            ...acc,
            [cur.comment_prop]: cur.comment,
            [cur.rating_prop]: cur.rating,
          }), {}
        );
        delete tmpForm[""];
        tmpForm.CustomerID = parseInt(this.$route.params.CustomerID);
        tmpForm.ReviewedBy = this.reviewedBy;

        let self = this;

        if (!self.isValid(tmpForm)) {
          self.$refs.ErrorModal.show();
          self.$refs.ErrorModal.setText(
            "There was an error saving your form. Please ensure everything is filled out"
          );

          setTimeout(() => {
            self.$refs.ErrorModal.hide();
          }, 3000);
            return;
        }

        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Submitting...");
        self
          .post(`SupplierEvaluationTx`, tmpForm, false)
          .then((r) => {
            if (r.data) {
              self.$refs.Loader.hide();

              self.$refs.SuccessModal.show();
              self.$refs.SuccessModal.setText("Succesful submittion");
              setTimeout(function () {
                self.$refs.SuccessModal.hide();
                self.$router.push("/login");
              }, 1000);
            } else {
              self.$refs.Loader.hide();
              self.$refs.ErrorModal.show();
              self.$refs.ErrorModal.setText(
                "There was an error saving your form."
              );
            }
          })
          .catch((error) => {
            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      },
    },
  };
</script>

<style scoped>
  table,
  th,
  td {
    border-collapse: collapse;
    border: 1px solid black;
  }
</style>